<div class="p-dialog-content__dynamic">
  <form action="" [formGroup]="form">
    <div class="form-row w-100">
      <div class="auto-complete form-element w-100">
        <label
          class="form-label"
          [class.required]="
            form.get('product')?.hasValidator(Validators.required)
          "
        >
          Assign Product To:
          <b>{{ user?.first_name + " " + user?.last_name }}</b>
        </label>
        <p-autoComplete
          class="w-100"
          formControlName="product"
          [multiple]="false"
          (completeMethod)="productFilter.onQueryChange($event)"
          (onSelect)="productFilter.onSelected($event)"
          [suggestions]="productFilter.suggestions"
          field="label"
          placeholder="Search To Select Product"
          appendTo="body"
          (onShow)="productFilter.paginationScrolling()"
        >
        </p-autoComplete>
        <app-form-errors
          [color]="'product'"
          [form]="form"
          [control]="form.get('product')"
        >
        </app-form-errors>

        <p *ngIf="isSameProductError" class="form-error">
          This product is already assigned to the dealer
        </p>
      </div>
    </div>
  </form>
</div>

<div class="p-dialog-footer p-dialog-footer__dynamic">
  <button class="cancel-btn medium" (click)="cancelClicked()">Cancel</button>
  <button
    class="regular-btn medium"
    (click)="saveClicked()"
    [disabled]="isSubmitLoading || isSameProductError"
  >
    Save
    <i *ngIf="isSubmitLoading" class="fa-spin fas fa-spinner ms-2"></i>
  </button>
</div>
